/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AudioRecorderFile,
  AudioRecorderInput,
  GetAudioRecorderFileParams,
  PaginatedAudioRecorderFiles,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List files
 */
export const listAudioRecorderFiles = (

 signal?: AbortSignal
) => {


      return axiosClient<PaginatedAudioRecorderFiles>(
      {url: `/audio_recorder/files`, method: 'GET', signal
    },
      );
    }




export const getListAudioRecorderFilesQueryKey = () => {
    return [
    'audio_recorder','files'
    ] as const;
    }


export const getListAudioRecorderFilesQueryOptions = <TData = Awaited<ReturnType<typeof listAudioRecorderFiles>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAudioRecorderFiles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAudioRecorderFilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAudioRecorderFiles>>> = ({ signal }) => listAudioRecorderFiles(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAudioRecorderFiles>>, TError, TData>
}

export type ListAudioRecorderFilesQueryResult = NonNullable<Awaited<ReturnType<typeof listAudioRecorderFiles>>>
export type ListAudioRecorderFilesQueryError = ErrorType<void>


/**
 * @summary List files
 */

export function useListAudioRecorderFiles<TData = Awaited<ReturnType<typeof listAudioRecorderFiles>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAudioRecorderFiles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAudioRecorderFilesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary File Details
 */
export const getAudioRecorderFile = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetAudioRecorderFileParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<AudioRecorderFile>(
      {url: `/audio_recorder/files/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetAudioRecorderFileQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetAudioRecorderFileParams>,) => {
    return [
    'audio_recorder','files',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAudioRecorderFileQueryOptions = <TData = Awaited<ReturnType<typeof getAudioRecorderFile>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetAudioRecorderFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudioRecorderFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAudioRecorderFileQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAudioRecorderFile>>> = ({ signal }) => getAudioRecorderFile(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAudioRecorderFile>>, TError, TData>
}

export type GetAudioRecorderFileQueryResult = NonNullable<Awaited<ReturnType<typeof getAudioRecorderFile>>>
export type GetAudioRecorderFileQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary File Details
 */

export function useGetAudioRecorderFile<TData = Awaited<ReturnType<typeof getAudioRecorderFile>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetAudioRecorderFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudioRecorderFile>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAudioRecorderFileQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update File
 */
export const updateAudioRecorderFile = (
    id: MaybeRefOrGetter<string>,
    audioRecorderInput: MaybeRefOrGetter<AudioRecorderInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
audioRecorderInput = toValue(audioRecorderInput);

      return axiosClient<AudioRecorderFile>(
      {url: `/audio_recorder/files/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: audioRecorderInput, signal
    },
      );
    }




export const getUpdateAudioRecorderFileMutationKey = () => ['updateAudioRecorderFile'] as const;

export const getUpdateAudioRecorderFileMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAudioRecorderFile>>, TError,UpdateAudioRecorderFileMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAudioRecorderFile>>, TError,UpdateAudioRecorderFileMutationVariables, TContext> => {

const mutationKey = getUpdateAudioRecorderFileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAudioRecorderFile>>, UpdateAudioRecorderFileMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateAudioRecorderFile(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAudioRecorderFileMutationResult = NonNullable<Awaited<ReturnType<typeof updateAudioRecorderFile>>>
    export type UpdateAudioRecorderFileMutationBody = AudioRecorderInput
    export type UpdateAudioRecorderFileMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateAudioRecorderFileMutationVariables = {id: string;data: AudioRecorderInput}

    /**
 * @summary Update File
 */
export const useUpdateAudioRecorderFile = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAudioRecorderFile>>, TError,UpdateAudioRecorderFileMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAudioRecorderFile>>,
        TError,
        UpdateAudioRecorderFileMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAudioRecorderFileMutationOptions(options), queryClient);
    }
